import { Component, ComponentRef, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ModalCadastroComponent } from '../../shared/modal-cadastro/modal-cadastro.component';
import { ProdutosDetalhesComponent } from '../produtos-detalhes/produtos-detalhes.component';

@Component({
  selector: 'app-modal-produtos',
  templateUrl: './modal-produtos.component.html',
  styleUrls: ['./modal-produtos.component.css']
})
export class ModalProdutosComponent extends ModalCadastroComponent implements OnInit {
  @ViewChild('modalCadastro', { static: true }) modalCadastro;
  @ViewChild('detalhaItemContainer', { read: ViewContainerRef, static: true }) detalhaItemContainer: ViewContainerRef;
  detalhaItemComponentRef: ComponentRef<ProdutosDetalhesComponent>;
  id: number = null;

  constructor() {
    super();
  }

  ngOnInit() {

  }

  show(params) {
    this.id = params.id;

    this.detalhaItemComponentRef = this.detalhaItemContainer.createComponent(ProdutosDetalhesComponent);
    this.detalhaItemComponentRef.instance.cadastroFactory = true;
    this.detalhaItemComponentRef.instance.component = 'ProdutosDetalhesComponent';
    this.detalhaItemComponentRef.instance.factoryId = params.id;
    this.detalhaItemComponentRef.instance.dentroModal = true;
    this.detalhaItemComponentRef.instance.appendTo = '#modal-cadastro-produtos';
    this.detalhaItemComponentRef.instance.preencherDados = params.preencherDados;
    
    this.detalhaItemComponentRef.instance.formFinished.subscribe(editedItem => {
      this.closed.emit(editedItem);
      this.modalCadastro.hide();
    });

    this.modalCadastro.show();
  }

  destroyComponent() {
    this.closed.emit();
  }

  get titulo() {
    return this.id ? 'Editar Produto' : 'Cadastrar produto';
  }
}
